import { render, staticRenderFns } from "./CompanyQualification.vue?vue&type=template&id=3063200c&scoped=true&"
import script from "./CompanyQualification.vue?vue&type=script&lang=js&"
export * from "./CompanyQualification.vue?vue&type=script&lang=js&"
import style0 from "./CompanyQualification.vue?vue&type=style&index=0&id=3063200c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063200c",
  null
  
)

export default component.exports